import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledToggleButton = styled(Button)(({ theme }) => ({
  paddingLeft: 0,
  paddingRight: theme.spacing(0.25),
  minWidth: 36,
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  paddingRight: theme.spacing(1.25),
}));
